import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { apiCall } from 'app/shared/lib/essette-api';
import { ProviderService } from 'app/cd/services/provider-service';
import { guid } from 'app/shared/lib/guid';
import { ICustomFieldTargetColumnsContainer, ICustomFieldTargetColumnsSettings } from 'app/shared/lib/custom-field-definitions';
import { CustomFieldContext } from 'app/core/lib/custom-field-context';
import * as CD from 'app/cd/models/essette-api';

@autoinject()
export class FacilityInfo extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected facilityViewId: string = `facility-information-view-${guid()}`;

    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    protected facilityId: string | null = null;

    protected provider: CD.Provider | null = null;
    protected facility: CD.ProviderFacility | null = null;
    protected customFieldTargetColumns: ICustomFieldTargetColumnsContainer | null = null;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly providerService: ProviderService,
        private readonly customFieldContext: CustomFieldContext,
        ...rest: any[]) {
        super(...rest);
    }

    protected bind(): void {
        this.loadCustomFieldTargets();
        this.reload();
    }

    ////****************** Events ***************************************************////
    protected async reload(): Promise<void> {
        await this.loadFacility();
    }

    ////****************** Functions ************************************************////
    @apiCall
    private async loadCustomFieldTargets(): Promise<void> {
        const settings: ICustomFieldTargetColumnsSettings = {
            filterInactive: true,
            sortByLabel: true
        };
        this.customFieldTargetColumns = await this.customFieldContext.getCustomFieldTargetColumns('CD.ProviderFacility', settings);
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadFacility(): Promise<void> {
        if(!this.facilityId) return;

        const includes = [
            'address.billing',
            'address.physical',
            'phoneNumber.fax',
            'phoneNumber.primary',
            'phoneNumber.secondary'
        ];

        try {
            this.state.beginLoad();

            const response = await this.providerService.loadProviderFacility(this.facilityId, includes);
            this.facility = response.results[0];
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
